export const CLASS_NAMES = {
  container: 'flex md:mb-6 flex-col',
  containerBottomMargin: 'mb-6 md:m-0 md:flex-1',
  title: 'text-18-22-em md:text-style-e text-neutral-900 mb-4',
  description: 'mb-4 md:mb-0 text-16-24 md:text-style-g text-neutral-600',
};
